import { each, go, noop, tap } from 'fxjs/es';
import { $find, $findAll, $on, $setHTML } from 'fxdom/es';
import { VectorEditorAcrylicFigureFreeCreatorPCMuiS } from '../../S/Mui/module/VectorEditorAcrylicFigureFreeCreatorPCMuiS.js';
import { VectorEditorTopMenuPCConstantS } from '../../../../../TopMenu/PC/S/Constant/module/VectorEditorTopMenuPCConstantS.js';
import { VectorEditorAcrylicFigureFreeCreatorPCF } from '../Function/module/VectorEditorAcrylicFigureFreeCreatorPCF.js';
import axios from 'axios';
import { VectorEditorFontF } from '../../../../../Font/F/Function/module/VectorEditorFontF.js';
import { CommonNS, EditorNS } from '@marpple/sticker-editor';

/*
 * 프론트에서 사용될 tab 옵션입니다.
 * https://www.notion.so/marpple/Marpple-UI-80875a30a63e436382a02e2d820f4695#2fecac9aa5f8457c92fa359c5ac71ef8
 * */
export const tab = {
  ...VectorEditorAcrylicFigureFreeCreatorPCMuiS.tab,

  inner_scroll_target: '', // modal 일때 이너 스크롤 엘리먼트 셀렉터

  makeData(tab) {}, // template 함수 인자에 들어갈 값을 리턴하는 함수,

  async appending(tab_el) {
    tab_el.__mp_title = tab_el.__mp_title ?? '';
    tab_el.__mp_price = tab_el.__mp_price ?? '';
    tab_el.__mp_acrylic_figure_editor = null;
    tab_el.__mp_art_board_width = tab_el.__mp_art_board_width ?? 0;
    tab_el.__mp_art_board_height = tab_el.__mp_art_board_height ?? 0;
    tab_el.__mp_art_board_shape_path_data = tab_el.__mp_art_board_shape_path_data ?? `M 0 0 Z`;
    tab_el.__mp_empty_template_el = tab_el.__mp_empty_template_el ?? null;
    tab_el.__mp_stand_leg_ground_size_delta = tab_el.__mp_stand_leg_ground_size_delta ?? 4;
    tab_el.__mp_stand_leg_ground_position_delta = tab_el.__mp_stand_leg_ground_position_delta ?? 1;
    tab_el.__mp_stand_leg_ground_min_width = tab_el.__mp_stand_leg_ground_min_width ?? 0;
    tab_el.__mp_stand_leg_ground_max_width = tab_el.__mp_stand_leg_ground_max_width ?? 0;
    tab_el.__mp_stand_leg_ground_width = tab_el.__mp_stand_leg_ground_width ?? 0;
    tab_el.__mp_stand_leg_ground_height = tab_el.__mp_stand_leg_ground_height ?? 0;
    tab_el.__mp_stand_leg_notch_round = tab_el.__mp_stand_leg_notch_round ?? 1;
    tab_el.__mp_stand_leg_notch_width = tab_el.__mp_stand_leg_notch_width ?? 0;
    tab_el.__mp_stand_leg_notch_height = tab_el.__mp_stand_leg_notch_height ?? 0;
    tab_el.__mp_postProcess = tab_el.__mp_postProcess ?? null;
    tab_el.__mp_preProcess = tab_el.__mp_preProcess ?? null;
    tab_el.__mp_fonts = null;
    tab_el.__mp_editor_container_el_resize_observer = null;

    go(tab_el, tap($findAll(`.right_container .right_panel_home .title`), each($setHTML(tab_el.__mp_title))));

    go(
      tab_el,

      tap(
        $findAll(`.right_container .button_container .cancel`),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleRightBottomCancelButtonClick())),
      ),
      tap(
        $findAll(`.right_container .button_container .next`),
        each(
          $on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleRightBottomNextButtonClick({ tab_el })),
        ),
      ),

      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.TOGGLE_LAYERS_MODE.ID}"]`,
        ),
        each(
          $on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuToggleLayerModeClick({ tab_el })),
        ),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.DUPLICATE.ID}"]`,
        ),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuDuplicateClick({ tab_el }))),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.DELETE.ID}"]`,
        ),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuDeleteClick({ tab_el }))),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.FORWARD.ID}"]`,
        ),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuForwardClick({ tab_el }))),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.BACKWARD.ID}"]`,
        ),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuBackwardClick({ tab_el }))),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.GROUP.ID}"]`,
        ),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuGroupClick({ tab_el }))),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.UNGROUP.ID}"]`,
        ),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuUngroupClick({ tab_el }))),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.FLIP_HORIZONTAL.ID}"]`,
        ),
        each(
          $on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuFlipHorizontalClick({ tab_el })),
        ),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.FLIP_VERTICAL.ID}"]`,
        ),
        each(
          $on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuFlipVerticalClick({ tab_el })),
        ),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.MOVE_TO_LEFT_END.ID}"]`,
        ),
        each(
          $on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuMoveToLeftEndClick({ tab_el })),
        ),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.MOVE_TO_HORIZONTAL_CENTER.ID}"]`,
        ),
        each(
          $on(
            'click',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuMoveToHorizontalCenterClick({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.MOVE_TO_RIGHT_END.ID}"]`,
        ),
        each(
          $on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuMoveToRightEndClick({ tab_el })),
        ),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.MOVE_TO_TOP_END.ID}"]`,
        ),
        each(
          $on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuMoveToTopEndClick({ tab_el })),
        ),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.MOVE_TO_VERTICAL_CENTER.ID}"]`,
        ),
        each(
          $on(
            'click',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuMoveToVerticalCenterClick({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(
          `.top_menu_container [data-top_menu_id="${VectorEditorTopMenuPCConstantS.TOP_MENU.MOVE_TO_BOTTOM_END.ID}"]`,
        ),
        each(
          $on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleTopMenuMoveToBottomEndClick({ tab_el })),
        ),
      ),

      tap(
        $findAll(`.left_menu[data-icon_type="upload_image"]`),
        each(
          $on(
            'click',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleLeftMenuUploadImageIconClick({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.left_menu[data-icon_type="my_image"]`),
        each(
          $on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleLeftMenuMyImageIconClick({ tab_el })),
        ),
      ),
      tap(
        $findAll(`.left_menu[data-icon_type="shape"]`),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleLeftMenuShapeIconClick({ tab_el }))),
      ),
      tap(
        $findAll(`.left_menu[data-icon_type="path"]`),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleLeftMenuPathIconClick({ tab_el }))),
      ),
      tap(
        $findAll(`.left_menu[data-icon_type="text"]`),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleLeftMenuTextIconClick({ tab_el }))),
      ),

      tap(
        $findAll(`.layer_container .header .close_layer`),
        each($on('click', VectorEditorAcrylicFigureFreeCreatorPCF.handleLayerCloseClick())),
      ),

      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/select',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorSelect({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/unselect',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorUnselect({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/add',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorAdd({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/remove',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorRemove({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/reorder',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorReorder({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/lock',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorLock({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/unlock',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorUnlock({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/show',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorShow({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/hide',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorHide({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/transform',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorTransform({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/attr-change',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorAttrChange({ tab_el }),
          ),
        ),
      ),
      tap(
        $findAll(`.editor_container`),
        each(
          $on(
            '@mp/sticker-editor/change-selector',
            VectorEditorAcrylicFigureFreeCreatorPCF.handleAcrylicFigureEditorChangeSelector({ tab_el }),
          ),
        ),
      ),
    );

    tab_el.__mp_fonts = await go(
      axios.get(`/${T.lang}/@api/maker/fonts`),
      (res) => res?.data,
      (fonts) => fonts ?? null,
    );
    await VectorEditorFontF.loadBaseFonts();
  }, // tab 엘리먼트가 만들어지면 울리는 함수
  async appended(tab_el) {
    const acrylic_figure_editor = new EditorNS.AcrylicEditorNS.PCNS.AcrylicPCEditor({
      window,
      document,
    });
    tab_el.__mp_acrylic_figure_editor = acrylic_figure_editor;
    acrylic_figure_editor.initDOM();
    acrylic_figure_editor.initEditor();
    acrylic_figure_editor.setArtBoardSize({
      width: tab_el.__mp_art_board_width,
      height: tab_el.__mp_art_board_height,
    });
    acrylic_figure_editor.setArtBoardShapePath({ path_data: tab_el.__mp_art_board_shape_path_data });
    acrylic_figure_editor.setArtBoardClipPathShapePath({ path_data: tab_el.__mp_art_board_shape_path_data });
    acrylic_figure_editor.turnOnArtBoardClipPath();
    const foreground_el = document.createElementNS(CommonNS.ConstNS.SVG_NAMESPACE, 'g');
    if (tab_el.__mp_empty_template_el != null) {
      foreground_el.appendChild(tab_el.__mp_empty_template_el);
    }
    acrylic_figure_editor.setForeground(foreground_el);

    const editor_container_el = $find('.editor_container')(tab_el);
    if (editor_container_el == null) {
      const error = new Error(`editor_container 클래스를 가진 엘리먼트를 찾을 수 없습니다.`);
      error.__mp_alert_message = T(
        'modules::VectorEditor::AcrylicFigure::Free::CreatorPC::error_message::no_editor_container_el',
      );
      throw error;
    }
    acrylic_figure_editor.appendTo(editor_container_el);

    tab_el.__mp_editor_container_el_resize_observer = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const { width, height } = entry.target.getBoundingClientRect();
        if (width <= 0 || height <= 0) {
          return;
        }
      }

      const editor = tab_el.__mp_acrylic_figure_editor;
      if (editor == null) {
        return;
      }

      editor.fitSize();
      const view_box_vo = editor.calculateViewBoxFitToArtBoard({
        padding_in_vcs: { top: 100, right: 200, bottom: 100, left: 200 },
      });
      editor.setViewBox(view_box_vo);
    });
    tab_el.__mp_editor_container_el_resize_observer.observe(editor_container_el);

    try {
      await tab_el.__mp_preProcess?.({ addEl: ({ el }) => acrylic_figure_editor.addEl(el) });
    } catch (error) {
      console.error(error);
      const message =
        error?.__mp_alert_message ??
        T('modules::VectorEditor::AcrylicFigure::Free::CreatorPC::error_message::no_pre_process');
      $.alert(message).catch(noop);
    }
  }, // tab 엘리먼트가 html에 붙으면 울리는 함수
  showing(tab_el) {}, // tab 엘리먼트 show하기 전 울리는 함수
  showed(tab_el) {
    if (tab_el.__mp_acrylic_figure_editor == null) {
      const error = new Error(`tab_el.__mp_acrylic_figure_editor 객체가 null 입니다.`);
      error.__mp_alert_message = T(
        'modules::VectorEditor::AcrylicFigure::Free::CreatorPC::error_message::no_acrylic_figure_editor',
      );
      throw error;
    }
    const editor = tab_el.__mp_acrylic_figure_editor;

    editor.fitSize();
    const view_box_vo = editor.calculateViewBoxFitToArtBoard({
      padding_in_vcs: { top: 100, right: 200, bottom: 100, left: 200 },
    });
    editor.setViewBox(view_box_vo);
  }, // tab 엘리먼트 show하고 나서 울리는 함수
  rendered(tab_el) {}, // tab 에 관련된 모든 메소드와 엘리먼트 작업이 끝날때 울리는 함수

  hiding(tab_el, v) {}, // tab이 가려지기 전 울리는 함수
  hided(tab_el, v) {}, // tab이 가려진 후 울리는 함수
  removing(tab_el, v) {}, // tab이 삭제되기 전 울리는 함수
  removed(tab_el, _v) {
    if (tab_el.__mp_acrylic_figure_editor != null) {
      const editor = tab_el.__mp_acrylic_figure_editor;
      editor.destroy();
    }
    if (tab_el.__mp_editor_container_el_resize_observer != null) {
      tab_el.__mp_editor_container_el_resize_observer.disconnect();
    }

    tab_el.__mp_title = '';
    tab_el.__mp_price = '';
    tab_el.__mp_acrylic_figure_editor = null;
    tab_el.__mp_art_board_width = 0;
    tab_el.__mp_art_board_height = 0;
    tab_el.__mp_art_board_shape_path_data = `M 0 0 Z`;
    tab_el.__mp_empty_template_el = null;
    tab_el.__mp_stand_leg_ground_size_delta = 0;
    tab_el.__mp_stand_leg_ground_position_delta = 0;
    tab_el.__mp_stand_leg_ground_min_width = 0;
    tab_el.__mp_stand_leg_ground_max_width = 0;
    tab_el.__mp_stand_leg_ground_width = 0;
    tab_el.__mp_stand_leg_ground_height = 0;
    tab_el.__mp_stand_leg_notch_round = 1;
    tab_el.__mp_stand_leg_notch_width = 0;
    tab_el.__mp_stand_leg_notch_height = 0;
    tab_el.__mp_postProcess = null;
    tab_el.__mp_preProcess = null;
    tab_el.__mp_fonts = null;
    tab_el.__mp_editor_container_el_resize_observer = null;
  }, // tab이 삭제된 후 울리는 함수

  infinite(tab_el) {}, // tab 엘리먼트에 무한스크롤을 사용할때 쓰는 함수, 사용시 반드시 return MuiF.tabInfinite(...)
};
